import { defineStore } from 'pinia'
import { store } from '@/stores'

export const useRouteStore = defineStore({
  id: 'app-route',
  state: () => ({
    menus: [],
    routers: [],
    keepAliveComponents: []
  }),
  getters: {
    getMenus() {
      return this.menus
    }
  },
  actions: {
    setMenus(menus) {
      this.menus = menus
    },
    setRouters(routers) {
      this.routers = routers
    },
    setKeepAliveComponents(compNames) {
      // 设置需要缓存的组件
      this.keepAliveComponents = compNames
    }
  }
})

export function useRouteStoreWithOut() {
  return useRouteStore(store)
}
